<template>
  <div class="application-tab application-inner">
    <div class="application-title">
      <span class="line lline"><i /><i /></span>
      <span class="word">{{title}}</span>
      <span class="line rline"><i /><i /></span>
    </div>
    <ul class="tabs-filter" v-if="tabfilter">
      <li class="tab-filter-item" v-for="(item, index) in tabfilter" :key="index" @click="toggleTabs(index)" :class="{active:index===currentTabIndex}">
        <span>{{ item }}</span>
      </li>
    </ul>
    <div class="tabs-content">
      <div class="content-item" v-for="(item, index) in tabcontent" :key="index" v-show="currentTabIndex === index">
        <img :src='"../assets/images/"+item+".png"'>
      </div>
      <!-- <div class="content-item" v-show="currentTabIndex2 === 0">
        <img src="../assets/images/zb-banner3.png">
      </div>
      <div class="content-item" v-show="currentTabIndex2 === 1">
        <img src="../assets/images/zb-banner4.png">
      </div> -->
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: String,
    tabfilter: Array,
    tabcontent: Array
  },
  data () {
    return {
      currentTabIndex: 0
    }
  },
  methods: {
    created () {
      // console.log(this.tabfilter, '---tabfilter---')
    },
    toggleTabs (index) {
      this.currentTabIndex = index
    }
  }
}
</script>

<style scoped>
.application-title {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  text-align: center;
  margin-top: 80px;
  margin-bottom: 60px;
}
.application-title .word {
  font-size: 30px;
  font-family: 'PingFangSC-Medium';
  /* color: #20253F; */
  color: #fff;
}
.application-title .lline {
  margin-right: 26px;
}
.application-title .rline {
  margin-left: 26px;
}
.application-title .line i {
  display: block;
  height: 1px;
  transform: scaleX(-1);
  background: #CACED5;
}
.application-title .line i:first-child {
  width: 71px;
}
.application-title .lline i:first-child {
  float: right;
}
.application-title .line i:last-child {
  width: 139px;
  margin-top: 11px;
}
.tabs-filter {
  display: flex;
  justify-content: center;
  margin: -20px 30px 40px;
  border-bottom: 1px solid rgba(223, 219, 219, .3);
}
.tab-filter-item {
  width: 11%;
  padding-bottom: 26px;
  text-align: center;
  font-size: 22px;
  color: rgba(255, 255, 255, .7);
  cursor: pointer;
  font-family: 'PingFangSC-Regular';
}
.tab-filter-item .tabicon {
  display: block;
  margin: 0 auto;
  /* zoom: 0.4; */
  transform: scale(0.5);
  -webkit-transform: scale(0.5);
  -moz-transform: scale(0.5);
  -o-transform: scale(0.5);
  position: relative;
  top: 10px;
  width: 98px;
  height: 98px;
}
.tab-filter-item:hover {
  color: #fff;
}
.tab-filter-item.active {
  position: relative;
  font-family: 'PingFangSC-Medium';
  font-size: 22px;
  color: #fff;
}
.tab-filter-item.active:after {
  display: inline-block;
  position: absolute;
  bottom: -1px;
  left: 50%;
  content: "";
  width: 17px;
  height: 3px;
  margin-left: -10px;
  background-color: #3A5FFF;
}
.tabs-content {
  padding-bottom: 40px;
}
.tabs-content .content-item {
  display: block;
  text-align: center;
}
.tabs-content .content-item img {
  width: 80%;
  margin: 0 auto;
}
.appcase-wrap .application-title {
  margin-top: 20px;
}
.appcase-wrap .tab-filter-item.active,
.appcase-wrap .tab-filter-item:hover {
  color: #fff;
}
.resolution-wrap .application-title .word,
.appcase-wrap .application-title .word
 {
  color: #fff;
}
.resolution-wrap .tab-filter-item,
.appcase-wrap .tab-filter-item {
  color: rgba(255, 255, 255, .7);
}
.resolution-wrap .tab-filter-item.active,
.resolution-wrap .tab-filter-item:hover {
  color: #fff;
}
/* 直播 */
.intro-zhibo-container .appcase-wrap .tab-filter-item {
  width: 17%;
}
.intro-zhibo-container .resolution-wrap .application-title {
  margin-bottom: 55px;
}
/* 搜索推荐 */
.intro-recommand-container .appcase-wrap .tab-filter-item {
  width: 30%;
}
/* 推送平台 */
.intro-push-container .appcase-wrap .tab-filter-item {
  width: 22%;
}
</style>



// WEBPACK FOOTER //
// src/components/application.vue